<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="120px"
               style="width: 400px; margin-left:50px;" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name"/>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-select
              v-model="form.gender"
              placeholder="性别"
              clearable
              style="width: 200px"
              class="filter-item"
              size="small"
          >
            <el-option label="男" :value="1"/>
            <el-option label="女" :value="2"/>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="department_id">
          <el-select
              v-model="form.department_id"
              placeholder="部门"
              clearable
              style="width: 200px"
              class="filter-item"
              size="small"
          >
            <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in departmentList"
                :key="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="工号" prop="employee_no">
          <el-input v-model="form.employee_no"/>
        </el-form-item>
        <el-form-item label="职级" prop="job_id">
          <el-select
              v-model="form.job_id"
              placeholder="职级"
              clearable
              style="width: 200px"
              class="filter-item"
              size="small"
          >
            <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in jobList"
                :key="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="上级领导" prop="superior_leader">
          <el-input v-model="form.superior_leader"/>
        </el-form-item>
        <el-form-item label="企业邮箱" prop="enterprise_email">
          <el-input v-model="form.enterprise_email"/>
        </el-form-item>
        <el-form-item label="证件号码" prop="id_number">
          <el-input v-model="form.id_number"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="$router.push('/employeeApplyLogs')" size="small" type="warning">返回</el-button>
        <el-button type="danger" @click="rejectModalVisible = true" size="small"
                   v-if="form.check_status==='pending'">审核驳回
        </el-button>
        <el-button type="success" @click="pass" :loading="btnLoading" size="small" v-if="form.check_status==='pending'">
          审核通过
        </el-button>
      </div>
    </div>
    <el-dialog
        title="驳回"
        :visible.sync="rejectModalVisible"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        append-to-body
        width="512px"
    >
      <el-form
          ref="rejectForm"
          :model="rejectForm"
          :rules="rejectRules"
          label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
              type="textarea"
              placeholder="驳回理由"
              :rows="4"
              v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject()"
          >确认
          </el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'

export default {
  components: {downloadExcel},
  data() {
    return {
      dialogFormVisible: false,
      dialogPvVisible: false,
      pvData: [],
      form: {
        id: '',
        name: '',
        permissions: []
      },
      rules: {
        name: [{required: true, message: '姓名不能为空', trigger: 'change'}],
        gender: [{required: true, message: '性别不能为空', trigger: 'change'}],
        department_id: [{required: true, message: '部门不能为空', trigger: 'change'}],
        permissions: [{type: 'array', required: true, message: '权限不能为空', trigger: 'change'}]
      },
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          {required: true, message: '请填写驳回理由', trigger: 'blur'},
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      exportLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: '',
        username: '',
        email: '',
        vip_level_no: '',
        revenue_type: '',
        start_at: '',
        end_at: '',
        is_active: '',
        status: '',
      },
      jobList: [],
      departmentList: [],
      btnLoading: false,
      btnLoading2: false,
      json_fields: {
        分红时间: {
          field: 'last_login_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        用户id: {
          field: 'id',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        姓: {
          field: 'last_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        名: {
          field: 'first_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        VIP等级: {
          field: 'vip_level_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        分红类型: {
          field: 'revenue_type',
          //自定义回调函数
          callback: (value) => {
            return (
                '<p style="mso-number-format:\'\\@\';">' +
                this.revenue_type(value) +
                '</p>'
            )
          },
        },
        来源对象: {
          field: 'source_user_id',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        来源动作: {
          field: 'num',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        奖金金额: {
          field: 'money_reward_value',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        RP: {
          field: 'rp_reward_value',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        结算状态: {
          field: 'status',
          //自定义回调函数
          callback: (value) => {
            return (
                '<p style="mso-number-format:\'\\@\';">' +
                this.status(value) +
                '</p>'
            )
          },
        },
        备注: {
          field: 'num',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
      },
    }
  },
  created() {
    this.getJobList()
    this.getDepartmentList()
    this.getDetail(this.$route.query.id)
    this.rejectForm.id = this.$route.query.id;
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },

  methods: {
    resetForm() {
      this.form = {
        id: '',
        name: '',
        gender: '',
        department_id: '',
        job_id: '',
        employee_no: '',
        superior_leader: '',
        enterprise_email: '',
        id_number: '',
      }

      this.btnLoading = false
    },
    handleReject() {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['rejectForm'].clearValidate()
      })

    },
    reject() {
      this.$refs['rejectForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          this.rejectForm.ids = [this.rejectForm.id]
          request({
            url: '/api/appClientend/employee/reject',
            method: 'post',
            data: this.rejectForm
          }).then(response => {
            this.btnLoading = false
            this.rejectModalVisible = false
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success',
              duration: 2000
            })
            this.getDetail(this.$route.query.id)
          }).catch((err) => {
            this.btnLoading = false
          })
        }
      })
    },
    pass() {
      this.btnLoading = true

      request({
        url: '/api/appClientend/employee/pass',
        method: 'post',
        data: this.form
      }).then(response => {
        this.btnLoading = false
        this.rejectModalVisible = false
        this.$notify({
          title: '成功',
          message: '保存成功',
          type: 'success',
          duration: 2000
        })
        this.getDetail(this.$route.query.id)
      }).catch((err) => {
        this.btnLoading = false
      })


    },
    getJobList() {
      request({
        url: '/api/appClientend/job/list',
        method: 'get',
        params: {limit: 999999999,weight_sort:'asc'},
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.jobList = res.data.data
        }
      })
    },
    getDepartmentList() {
      request({
        url: '/api/appClientend/department/list',
        method: 'get',
        params: {limit: 999999999,weight_sort:'asc'},
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.departmentList = res.data.data
        }
      })
    },
    handleExport() {
      if (!this.listQuery.start_at || !this.listQuery.end_at) {
        this.$message.warning('请选择开始与结束日期')
        return
      }
      this.exportLoading = true
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      return request({
        url: '/api/backend/dataCount/revenueDataCountList',
        method: 'get',
        params: listQuery,
      })
          .then((response) => {
            return response.data.data
          })
          .finally(() => {
            this.exportLoading = false
          })
    },
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0] + ' 00:00:00'
        this.listQuery.end_at = val[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    getDetail(id) {
      request({
        url: '/api/appClientend/employee/applyLogDetail',
        method: 'get',
        params: {
          id: id
        },
      }).then((response) => {
        this.form = response.data
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/member/editmemberinfo')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
